import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoomsApiService } from '@core/services';
import { catchError, map, of } from 'rxjs';
import { LiveReportState } from '../room/live-report.state';

/**
 * Resolves the room before the page is created, so the first render already carries its appearance.
 * Loaded into the state and not into route data, which a later hub push could not replace.
 */
export const LiveReportRoomGuard: CanActivateFn = (route) => {
  const roomsApi = inject(RoomsApiService);
  const state = inject(LiveReportState);
  const router = inject(Router);

  const roomSlug = route.paramMap.get('roomSlug');

  if (!roomSlug) {
    return of(router.parseUrl('/'));
  }

  // Unknown room, missing rights, backend down: none of them has a report to show, so none of them
  // stays here.
  return roomsApi.get(roomSlug).pipe(
    map((room) => {
      state.setRoom(room);
      return true;
    }),
    catchError(() => of(router.parseUrl('/'))),
  );
};
